"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FuseSearchBarModule = /** @class */ (function () {
    function FuseSearchBarModule() {
    }
    return FuseSearchBarModule;
}());
exports.FuseSearchBarModule = FuseSearchBarModule;
